// @flow

import React from 'react'
import styled, { css } from 'styled-components'
import Colors from 'styles/colors'
import { mediaMax } from 'styles/media'
import { fontSize } from 'frontend_core/dist/styles/variables'

const H1 = styled.h1`
  color: ${Colors.mono.gray100};
  font-size: ${props => props.fontSize || 20}px;
  font-weight: bold;
  ${({ textAlign }) =>
    textAlign &&
    css`
      text-align: ${textAlign};
    `} ${mediaMax.phone`
    font-size: ${fontSize.medium_2}px;
  `};
`

const H2 = styled.h2`
  color: ${Colors.mono.gray100};
  font-size: ${props => props.fontSize || fontSize.medium_2}px;
  ${({ textAlign }) =>
    textAlign &&
    css`
      text-align: ${textAlign};
    `};
`

const H3 = styled.h3`
  color: ${Colors.mono.gray100};
  font-size: ${props => props.fontSize || fontSize.medium_2}px;
  ${({ textAlign }) =>
    textAlign &&
    css`
      text-align: ${textAlign};
    `};
`

function getTitleTag(props) {
  switch (props.tag) {
    case 'h2':
      return <H2 fontSize={props.fontSize}>{props.children}</H2>
    case 'h3':
      return <H3 fontSize={props.fontSize}>{props.children}</H3>
    default:
      return <H1 fontSize={props.fontSize}>{props.children}</H1>
  }
}

export type PropTypes = {
  textAlign: string,
  tag?: string,
}

export default (props: PropTypes) => getTitleTag(props)
